/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import CrisisPlanDeclaredJournalEvent from "parog-web/models/crisis-plan-declared-journal-event";
export default class CrisisPlanFormComponent extends JournalEventBasedComponent {
  static forcDisplayName = "Définition du plan de crise";
  static fullComponentId = "crisis-plan/edition-form";

  static journalEventClass = CrisisPlanDeclaredJournalEvent;
  journalEventProperties = [
    "occurredAt",
    "crisisPlanDate",
    "mentalWarnings",
    "mentalActionsToTake",
    "mentalContacts",
    "depressiveWarnings",
    "depressiveActionsToTake",
    "depressiveContacts"
  ];

  retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();
    return payload;
  }
}
